//import { uniqBy } from 'lodash-es'
 

export const useFilterElement = () => {
  // Ako imaš plugin $srbTolat
   const { uniqByKey } = useCollectionUtils()

  // === createElement ===
  const createElement = (items, route, slugifyFn) => {
    const res = []
    const elements =  uniqByKey(items.additionals, 'additional_subcategory_id')

    const brandType = '_' + slugifyFn('Brend')
    
   
    const objBrand = {
      name: 'Brend',
      additional_subcategory_id: 0,
      type: brandType,
      options: items.brands,
      selects: getElementByRoute(route, brandType, 2)
    }
    res.push(objBrand)

    elements.forEach((el) => {
      const type = '_' + slugifyFn(el.s_name)

      const obj = {
        name: el.s_name,
        additional_subcategory_id: el.additional_subcategory_id,
        type,
        options: items.additionals.filter(
          (x) => x.additional_subcategory_id === el.additional_subcategory_id
        ),
        selects: getElementByRoute(route, type, 2)
      }

      res.push(obj)
    })

    return res
  }

  // === getElement ===
  const getElement = (routeFilter, type) => {
    if (routeFilter == null) return []
    const routeSplit = routeFilter.split('&')
    const result = routeSplit
      .filter((x) => x.includes(type))
      .toString()
      .split(type)
      .toString()
      .split('-')
      .join('')
      .split(',')
      .filter((x) => x)

    return result
  }

  // === getElementByRoute (wrapper) ===
  const getElementByRoute = (routeFilter, type, flag) => {
    if (flag === 1) return getElementByRouteString(routeFilter, type)
    return getElementByRouteArray(routeFilter, type)
  }

  // === getElementByRouteString ===
  const getElementByRouteString = (routeFilter, type) => {
    if (routeFilter == null) return ''
    const routeSplit = routeFilter.split('&')
    const result = routeSplit
      .filter((x) => x.includes(type))
      .toString()
      .split(type)
      .toString()
      .split('-')
      .join(' ')
      .split(',')
      .filter((x) => x)
      .map((x) => x.trimStart())
      .filter((x) => x !== type)
      .toString()
      .replace(',', '')

    return result
  }

  // === getElementByPrice ===
  const getElementByPrice = (routeFilter, type) => {
    if (routeFilter == null || routeFilter === undefined) {
      return {
        value1: 0,
        value2: 1000000
      }
    }

    const routeSplit = routeFilter.split('&')
    const result = routeSplit
      .filter((x) => x.includes(type))
      .toString()
      .split(type)
      .toString()
      .split('-')
      .join(' ')
      .split(',')
      .filter((x) => x)
      .map((x) => x.trimStart())
      .filter((x) => x !== type)
      .toString()
      .replace(',', '')

    if (result.trim() !== '') {
      return {
        value1: result.split(' ')[1],
        value2: result.split(' ')[3]
      }
    }

    return {
      value1: 0,
      value2: 1000000
    }
  }

  // === getElementByRouteArray ===
  const getElementByRouteArray = (routeFilter, type) => {
    if (routeFilter == null) return []
    const routeSplit = routeFilter.split('&')
    const result = routeSplit
      .filter((x) => x.includes(type))
      .toString()
      .split(type)
      .toString()
      .split('-')
      .join(' ')
      .split(',')
      .filter((x) => x)
      .map((x) => x.trimStart().split(' ').join('-') + type)
      .filter((x) => x !== type)

    return result
  }

  // === createFilterParams ===
  const createFilterParams = async (selects, params) => {
    try {
      const objects = {}

      selects.forEach((x) => {
        if (x.selects.length > 0) {
          objects[x.type] = x.selects.map((val) =>
            val
              .split('-')
              .join('')
              .split('(')
              .join('')
              .split(')')
              .join('')
          )
        }
      })

      const result = {
        params: {
          category: params.category,
          subcategory: params.subcategory,
          sort: params.sort,
          ...objects
        }
      }

      return result
    } catch (error) {
      return { params: {} }
    }
  }

  // === createFilterParams2 ===
  const createFilterParams2 = async (selects) => {
    try {
      const objects = {}
      const filter = selects.filter((x) => x.name !== 'Brend')

      filter.forEach((x) => {
        if (x.selects.length > 0) {
          objects[x.type] = x.selects.map((val) =>
            val
              .split('-')
              .join('')
              .split('(')
              .join('')
              .split(')')
              .join('')
          )
        }
      })

      return objects
    } catch (error) {
      return { params: {} }
    }
  }

  // === getSubcategoryByName ===
  const getSubcategoryByName = (category, name, slugifyFn) => {
    if (category && category.children?.length > 0) {
      const find = category.children.filter(
        (x) => slugifyFn(x.name_display) === name
      )

      if (find.length > 0) {
        return find[0]
      }
    }

    return null
  }

  // === generateMetaDescription ===
  const generateMetaDescription = (text, maxLength = 144) => {

    if(text == null) return '';
    
    const cleanedText = text.replace(/\s+/g, ' ').trim()

    return cleanedText.length > maxLength
      ? cleanedText.slice(0, maxLength).trim() + '...'
      : cleanedText
  }

  // === getIdByUrl ===
  const getIdByUrl = (url) => {
    const match = url.match(/-(\d+)-cene/)
    const number = match ? match[1] : null
    return number
  }
const parseFilterString = (input) => {
  // 1) Brendovi: sve što ima suffix "_brend"
  const brandMatches = [...input.matchAll(/([^-_]+)_brend/g)];
  const brandsArray = brandMatches.map(m => m[1]);
  const brands = brandsArray.length ? brandsArray.join(',') : ''; 

  // 2) Pretraga: prvo što ima suffix "_pretraga"
  const searchMatch = input.match(/([^-_]+)_pretraga/);
  // ovde biraj: '' ili null kad nema _pretraga
  const search = searchMatch ? searchMatch[1] : null;

  // 3) Cena: od-<min>-do-<max>_cena
  // podržava i cele brojeve i decimale (npr. 25.5)
  const priceMatch = input.match(/od-(\d+(?:\.\d+)?)-do-(\d+(?:\.\d+)?)_cena/);
  const minPrice = priceMatch ? Number(priceMatch[1]) : null;
  const maxPrice = priceMatch ? Number(priceMatch[2]) : null;

  return { search, brands, minPrice, maxPrice };
}

  return {
    createElement,
    getElement,
    getElementByRoute,
    getElementByRouteString,
    getElementByPrice,
    getElementByRouteArray,
    createFilterParams,
    createFilterParams2,
    getSubcategoryByName,
    generateMetaDescription,
    getIdByUrl,
    parseFilterString
  }
}
